//export const lineColorsList: string[] = ['#7B9234', '#F36C35'];
export const lineColorsList: string[] = ["#D17925", "#6A6AB1"];
//export const colorsList: string[] = ['#007EAE', '#2691BA', '#4CA4C6', '#73B8D3'];
//export const colorsList: string[] = ['#73B8D3', '#4CA4C6', '#2691BA', '#007EAE'];
// export const colorsList: string[] = ['#007EAE', '#F36C35', '#7B9234', '#D15983', '#6A6AB1'];
export const colorsList: string[] = [
  "#B92051",
  "#006D89",
  "#9D5700",
  "#125E1F",
  "#501555",
  "#1D3BAA",
  "#54BAA0",
  "#00495B",
  "#C94100",
  "#000",
  "#EC8200",
  "#566CBF",
  "#CD6083",
];

export const createLineSeries = (yKeys: any) =>
  yKeys.map((key: any, index: any) => ({
    type: "line",
    xKey: "Month",
    yKey: key,

    tooltip: {
      renderer: (params: any) => {
        return `<div style="padding: 8px"> <b>${params.datum["Month"]} ${key} </b> <br> 
                    ${params.datum[key].toLocaleString("en-US", { maximumFractionDigits: 0 })}</div>`;
      },
    },
    stroke: lineColorsList[index % lineColorsList.length],
    marker: {
      fill: lineColorsList[index % lineColorsList.length],
      stroke: lineColorsList[index % lineColorsList.length],
    },
  }));

export const createLineChartOptions = (series: any, data: any) => {
  return {
    data: data,
    series: series,
    //legend: {position: 'right'},
    //width: 600,
    height: window.innerHeight * 0.45,
    axes: [
      { type: "category", position: "bottom", crosshair: { enabled: true } },
      {
        type: "number",
        position: "left",
        label: {
          formatter: (params: any) => {
            return params.value.toLocaleString("en-US", {
              notation: "compact",
              maximumFractionDigits: 1,
            });
          },
        },
      },
    ],
    contextMenu: { enabled: false },
  };
};

export const createBarChartOptions = (
  series: any,
  data: any,
  count: string,
  percent: any,
  height?: any,
  width?: any,
  totalSum?: any,
  isForAll?: boolean,
) => {
  let axisMax = 100;

  if (isForAll && Array.isArray(data) && series?.length) {
    const xKey = series[0].xKey;
    const stackedTotals = data.map((row: any) =>
      series.reduce((sum: number, s: any) => sum + (row[s.yKey] || 0), 0),
    );

    axisMax = Math.max(...stackedTotals);
  }

  return {
    data,
    series,
    title: { text: count, fontSize: 11, fontWeight: "bold", spacing: 2 },
    subtitle: {
      text: percent + "%",
      fontSize: 11,
      fontWeight: "normal",
      spacing: 10,
    },
    axes: [
      { type: "category", position: "bottom" },
      {
        type: "number",
        position: "left",
        min: 0,
        max: 100,
        gridLine: { enabled: false },
        label: { enabled: false },
        crosshair: { enabled: false },
      },
    ],
    legend: { enabled: false },
    height,
    width,
    contextMenu: { enabled: false },
  };
};
export const createSeries = (yKey: any, index: any) => [
  {
    type: "bar",
    xKey: "category",
    yKey: yKey,
    tooltip: {
      renderer: (params: any) => {
        return `<div style="padding: 8px"><b>${params.yKey}</b> <br> ${params.datum[yKey].toLocaleString("en-US", { maximumFractionDigits: 0 })}</div>`;
      },
    },

    fill: colorsList[index % colorsList.length],
  },
];

export function createFormData({
  cube,
  schema,
}: {
  cube: string;
  schema: string;
}) {
  const formData = new FormData();
  formData.append("connection", "fi");
  formData.append("cube", cube);
  formData.append("catalog", schema);
  formData.append("schema", schema);
  return formData;
}

const xKey = "[Vehicle Count]";
export const groupAndSumVehicleCounts = (vehicleData: any, categories: any) => {
  // Handle null/undefined vehicleData
  if (!vehicleData || !Array.isArray(vehicleData)) {
    return {};
  }

  const result: any = {};
  const months = vehicleData
    .map((row: any) => row?.["Month"])
    .filter((month: any) => month !== null && month !== undefined);

  // Handle empty months
  if (months.length === 0) {
    return result;
  }

  const monthsList: string[] = [...new Set(months)].sort((a: any, b: any) => {
    const timeA = new Date(a).getTime();
    const timeB = new Date(b).getTime();
    // Handle invalid dates
    if (isNaN(timeA) || isNaN(timeB)) {
      return 0;
    }
    return timeA - timeB;
  }) as string[];

  for (const month of monthsList) {
    result[month] = 0;
  }

  if (categories && categories.length > 0) {
    vehicleData.forEach((row: any) => {
      const gvw = row?.["VIN GVW Class"];
      const month = row?.["Month"];
      const count = row?.[xKey] || 0;

      if (month && gvw !== null && gvw !== undefined) {
        if (categories.includes(gvw) || categories.includes(Number(gvw))) {
          result[month] = (result[month] || 0) + count;
        }
      }
    });
  } else {
    //for all vehicles
    vehicleData.forEach((row: any) => {
      const monthName = row?.["Month"];
      const count = row?.[xKey] || 0;

      if (monthName) {
        const matchingMonth = monthsList.find((month) =>
          month?.includes?.(monthName),
        );
        if (matchingMonth) {
          result[matchingMonth] = (result[matchingMonth] || 0) + count;
        }
      }
    });
  }

  return result;
};

export const groupAndSumVehicleCountsVio = (
  vehicleData: any,
  categories: any,
) => {
  // Handle null/undefined vehicleData
  if (!vehicleData || !Array.isArray(vehicleData)) {
    return {};
  }

  const result: any = {};
  for (const category in categories) {
    result[category] = 0;
  }

  vehicleData.forEach((row: any) => {
    const gvw = row?.["VIN GVW Class"];
    const count = row?.[xKey] || 0;

    if (gvw !== null && gvw !== undefined) {
      for (const category in categories) {
        if (
          categories[category].includes(gvw) ||
          categories[category].includes(Number(gvw))
        ) {
          result[category] = (result[category] || 0) + count;
        }
      }
    }
  });

  return result;
};

export const getCardData = (key: string, data: any) =>
  data.find((item: any) => item.key === key);
